import React, { PureComponent, createRef } from 'react';
import Auth from '@aws-amplify/auth';
import { Link } from 'react-router-dom';
import { email as validateEmail } from '@mhub/web-validations';
import {
  Container, Label, Input, Form, Button,
} from '@mhub/web-components';

import AppHeader from '../../components/AppHeader';
import AppFooter from '../../components/Footer';
import { AppContext } from '../../context';
import Loading from '../Loading';
import './styles.css';

export default class Login extends PureComponent {
  state = {
    data: {
      email: '',
      password: '',
    },
    lockPassword: false,
  };

  emailRef = createRef();

  componentDidMount() {
    const { current } = this.emailRef;
    if (current) {
      current.focus();
    }
  }

  handleOnChange = (e, { name, data }) => {
    const authConfig = Auth.configure();
    const { oauth } = authConfig;
    if (!oauth) {
      return;
    }
    const { lockPassword: currentLock } = this.state;
    let lockPassword = false;
    if (name === 'email') {
      const { email } = data;
      if (email.match(/@spsetia/i)) {
        lockPassword = true;
      }
    }
    if (lockPassword !== currentLock) {
      this.setState({ lockPassword });
    }
  }

  handleOnSubmit = (e, { email, password }) => {
    e.preventDefault();
    const { actions } = this.context;
    actions.signIn(email, password);
  }

  static contextType = AppContext;

  renderEmailInput = ({
    name, onChange, onValidate, validateRef, disabled,
  }) => (
    <Label name={name} content="Company email">
      <Input.Validate
        ref={this.emailRef}
        validateRef={validateRef}
        fluid
        type="email"
        onChange={onChange}
        onValidate={onValidate}
        label="Email"
        validations={[validateEmail]}
        disabled={disabled}
        tabIndex={-5}
        autoComplete="username"
        autoFocus
      />
    </Label>
  )

  renderPasswordInput = ({
    name, onChange, onValidate, validateRef, disabled,
  }) => {
    const { lockPassword } = this.state;
    return (
      <Label
        name={name}
        content="Password"
        onClick={e => e.preventDefault()}
        rightNode={(
          <Button
            as={Link}
            className="ForgotButton"
            color="blue"
            basic
            to="/forgot_password"
            tabIndex={-2}
          >
            Forgot password
          </Button>
        )}
      >
        <Input.Validate
          validateRef={validateRef}
          fluid
          type="password"
          onChange={onChange}
          onValidate={onValidate}
          disabled={disabled || lockPassword}
          tabIndex={-4}
          autoComplete="current-password"
        />
      </Label>
    );
  }

  render() {
    const { state } = this.context;
    const { data, lockPassword } = this.state;
    const { loading, isADFS } = state;
    if (isADFS) {
      return <Loading />;
    }
    return (
      <Container className="Login" scrollable noContent>
        <AppHeader header="Hi!">
          <p>
            Welcome to our growing community.
          </p>
          <p>
            Let&apos;s get started.
          </p>
        </AppHeader>
        <Form
          data={data}
          disabled={loading}
          onChange={this.handleOnChange}
          onSubmit={this.handleOnSubmit}
        >
          <Form.Field name="email" required>
            {this.renderEmailInput}
          </Form.Field>
          <Form.Field name="password" required={!lockPassword}>
            {this.renderPasswordInput}
          </Form.Field>
          <Form.Consumer>
            {
              ({ disabled, hasError, hasRequiredData }) => (
                <Button
                  className="SubmitButton"
                  ripple
                  color="blue"
                  type="submit"
                  disabled={disabled || hasError || !hasRequiredData}
                  tabIndex={-3}
                >
                  LOGIN
                </Button>
              )
            }
          </Form.Consumer>
        </Form>
        <AppFooter>
          <p>
            Don&apos;t have an account?&nbsp;
            <Button
              basic
              as={Link}
              color="blue"
              to="/register"
              tabIndex={-1}
            >
              Sign up here.
            </Button>
          </p>
          <p>
            By clicking on the submit button above you agree to MHub&apos;s&nbsp;
            <Button
              basic
              as="a"
              color="blue"
              href="https://mhub.my/policies/terms_of_use/"
            >
              Terms of Use.
            </Button>
          </p>
        </AppFooter>
      </Container>
    );
  }
}
